import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { apiCall, apiClient } from 'shared/client/apiClient';
import { setPlenaryContextId } from 'shared/client/utils/plenaryIdentity';
import { AuthenticatePlenaryStudentRequestBodyType } from 'shared/common/dtos/plenary/authenticatePlenaryStudent';

const authenticatePlenaryStudent = async (studentAuthenticateDto: AuthenticatePlenaryStudentRequestBodyType) => {
  const data = await apiCall(
    apiClient.POST('/plenary-contexts/students/authenticate', { body: studentAuthenticateDto })
  );
  return data;
};

export const useAuthenticatePlenaryStudentQuery = (
  studentAuthenticateDto: AuthenticatePlenaryStudentRequestBodyType,
  enabled: boolean
) => {
  const query = useQuery({
    queryKey: ['plenary-student', { activityInformation: studentAuthenticateDto.activityInformation }],
    queryFn: () => authenticatePlenaryStudent(studentAuthenticateDto),
    enabled,
    retry: false
  });

  useEffect(() => {
    if (!query.dataUpdatedAt || !query.data) return;
    setPlenaryContextId(query.data.contextId);
  }, [query.dataUpdatedAt, query.data]);

  return query;
};
